import { render, staticRenderFns } from "./global-snack.vue?vue&type=template&id=a4f2a94a&scoped=true"
import script from "./global-snack.vue?vue&type=script&lang=js"
export * from "./global-snack.vue?vue&type=script&lang=js"
import style0 from "./global-snack.vue?vue&type=style&index=0&id=a4f2a94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f2a94a",
  null
  
)

export default component.exports